/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Add_Method_Google_HelpInputs */



/**
* | output |
* | --- |
* | "Send an invitation that requires the user to sign in with their Google account to join." |
*
* @param {Members_Add_Method_Google_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_add_method_google_help = /** @type {((inputs?: Members_Add_Method_Google_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Add_Method_Google_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sendet eine Einladung, bei der sich der Benutzer mit seinem Google-Konto anmelden muss, um beizutreten.")
	return /** @type {LocalizedString} */ ("Send an invitation that requires the user to sign in with their Google account to join.")
});